import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 44EDC206-CF12-4DA5-8DA6-E72FDC35BBD2
 * name music-note-eighth
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-note-eighth.svg
 * tags
 * - Audio 
 * - Music 
 */
export const MusicNoteEighthIcon = createSvgIcon(<><path d="M12 3V13.55C11.41 13.21 10.73 13 10 13C7.79 13 6 14.79 6 17S7.79 21 10 21 14 19.21 14 17V7H18V3H12Z" /></>, 'MusicNoteEighthIcon');
export default MusicNoteEighthIcon